var dict = {
  "app_id": 207815,
  "exhibitionId": "",
  "projectId": "",
  "AppId": ""
}

export default dict;